import { render, staticRenderFns } from "./salesReturnsTakeIn.vue?vue&type=template&id=b6489ee8&"
import script from "./salesReturnsTakeIn.vue?vue&type=script&lang=js&"
export * from "./salesReturnsTakeIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "salesReturnsTakeIn.vue"
export default component.exports